<template>
    <modal-base :pacifier="false">
        <template #title>Sorry, something seems to have not worked correctly.</template>

        <template #subtitle>Your information has still been passed on to your Unbundled Attorney.</template>
    </modal-base>
</template>

<script>
    export default {
        mounted() {
            this.$store.commit('card');
        }
    }
</script>
